
function offsetSidebar(element, offset = 14) {
  if (element === "undefined") {
    return;
  }
  const sidebarOffset = document.querySelector(element)?.getBoundingClientRect().height;
  let t;
  clearTimeout(t);
  t = setTimeout(() => {
    if (document.querySelector(".sidebar") && window.innerWidth >= 1024) {
      document.querySelector(".sidebar").style.marginTop = `${sidebarOffset + offset}px`;
    } else {
      document.querySelector(".sidebar").style.marginTop = 0;
    }
  }, 100);
}

/* When the threshold for related articles has been reached, the leftover items are hidden. This click shows them */
const relatedLoadMoreTrigger = document.querySelector("[data-related-articles-load-trigger]");
relatedLoadMoreTrigger?.addEventListener("click", function () {
  relatedLoadMoreTrigger.querySelector("[data-load-text]").classList.add("hidden");
  relatedLoadMoreTrigger.querySelector("[data-loader]").classList.remove("hidden");
  this.remove();
  document.querySelector("[data-related-articles-hidden]")?.classList.remove("hidden");
});


const elementToOffset = '.related-articles__title';
window.addEventListener('load', offsetSidebar(elementToOffset,20));
window.addEventListener('resize', () => {
  offsetSidebar(elementToOffset,20);
});